import { Link } from 'react-router-dom';
import { StudentNotesPanel } from '../../features/notes/StudentNotesPanel';
import { formatDuration } from '../../features/pilotMath/format';
import { pilotSummary } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';

export function ParentDashboard() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const needsCorrection = state.attempts.filter((attempt) => !attempt.firstAttemptCorrect).length;

  return (
    <div className="stack">
      <div><h1>Progress {state.student.displayName}</h1><p className="muted">Ringkasan orang tua dari record dan history belajar pilot.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Selesai hari ini</span><strong>{summary.completed}/{summary.totalQuestions}</strong></div>
        <div className="metric"><span>First-attempt</span><strong>{summary.firstAttemptAccuracy}%</strong></div>
        <div className="metric"><span>Waktu aktif</span><strong>{formatDuration(summary.totalActiveMs)}</strong></div>
      </section>
      <section className="card">
        <h2>Ringkasan hari ini</h2>
        {state.attempts.length === 0
          ? <p className="muted">{state.student.displayName} belum mulai latihan Matematika hari ini.</p>
          : <p>{state.student.displayName} telah mengerjakan <strong>{summary.completed}</strong> soal. <strong>{needsCorrection}</strong> soal memerlukan koreksi pada jawaban pertama.</p>}
        <div className="button-row"><Link className="btn" to="/parent/progress">Lihat detail progress</Link></div>
      </section>
      <StudentNotesPanel
        studentId={state.student.id}
        viewerRole="guardian"
        authorName="Orang Tua Andi"
        allowCreate
        defaultNoteType="parent"
        subjectCode="MTH"
        title="Catatan rumah & tindak lanjut"
      />
    </div>
  );
}
